<template>
  <div class="flex add_name flex-col py-5 px-5" v-if="open_route_name_popup">
    <div class="top flex justify-between">
      <h2 class="text-left">Save route</h2>
      <span @click="closePopup" class="close pointer">x</span>
    </div>
    <div class="input_group flex flex-col">
      <label class="text-left">Route name</label>
      <input v-model="route_name" type="text">
    </div>
    <div class="input_group flex flex-col">
      <label class="text-left">Assign driver</label>
      <div v-if="!all_drivers.length" class="text-left text-sm text-grey-dark">
        No drivers available
      </div>
      <CustomSelect
        v-else
        :view="'name'"
        :array="all_drivers"
        :initial-label="selectedDriverLabel"
        @selected-item-in-custom-select="selectDriver"
      />
    </div>
    <div class="actions py-3 flex w-2/3 m-auto gap-15">
      <button class="white-green w-1/2" @click="closePopup">Cancel</button>
      <button class="green-white w-1/2" @click="saveDirections">Save</button>
    </div>
  </div>
</template>
<script>
import CustomSelect from "@/components/customel/CustomSelect.vue";
import {infoMessage} from "@/services/messages";

export default {
  name: 'SaveRoutePopup',
  components: {
    CustomSelect,
  },
  props: {
    open_route_name_popup: {
      type: Boolean,
      default: false,
    },
    selected_driver_id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      route_name: '',
      driver_id: null,
      all_drivers: [],
    };
  },
  computed: {
    selectedDriverLabel() {
      if (!this.driver_id || !this.all_drivers.length) {
        return '';
      }
      const driver = this.all_drivers.find((item) => item.id === this.driver_id);
      return driver?.name || '';
    },
  },
  methods: {
    closePopup() {
      this.$emit('close');
    },
    selectDriver(driver) {
      this.driver_id = driver?.id ?? null;
    },
    async loadDrivers() {
      const res = await this.$http.getAuth(`${this.$http.apiUrl()}/drivers/all`).catch((err) => {
        console.error(err);
        this.all_drivers = [];
        infoMessage('Oops. Something went wrong...', 'error');
        return null;
      });

      this.all_drivers = res?.data?.drivers || [];
    },
    syncFromProps() {
      this.driver_id = this.selected_driver_id ?? null;
    },
    saveDirections() {
      this.$emit('saveDirections', {
        name: this.route_name,
        driver_id: this.driver_id ?? null,
      });
    },
  },
  watch: {
    async open_route_name_popup(isOpen) {
      if (!isOpen) {
        return;
      }
      this.syncFromProps();
      await this.loadDrivers();
    },
    selected_driver_id(val) {
      if (this.open_route_name_popup) {
        this.driver_id = val ?? null;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.add_name {
  position: absolute;
  max-width: 400px;
  left: 0;
  right: 0;
  top: 300px;
  margin: auto;
  z-index: 401;
  background: #fff;
}

.input_group + .input_group {
  margin-top: 12px;
}
</style>
